import styled from "@emotion/styled"

import { scale } from "@utils/typography"

const Wrapper = styled.div`
  height: ${props => props.height || "500px"};
`

const Label = styled.tspan`
  ${scale(1 / 8)};
  font-weight: 700;
`

const Tooltip = styled.span`
  color: ${props => props.theme.color};
`

export { Label, Tooltip, Wrapper }
